<template>
  <div class="is-border-top">
    <div class="statisticsRows-header statisticsRows-header--sticky is-border-right is-border-left has-background-white">
      <div class="columns is-gapless is-size-7-touch is-size-7-desktop is-size-6-widescreen">
        <div class="columns column is-2">
          <div class="column is-th is-7 is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="$emit('sort', 'user_name', $event)"
              sort-id="user_name"
              :sort="sortBy.user_name"
              label="Commercial"></sortable>
          </div>
          <div class="column is-th is-5 is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="$emit('sort', 'account_name', $event)"
              sort-id="account_name"
              :sort="sortBy.account_name"
              label="Société"></sortable>
          </div>
        </div>
        <div class="columns column">
          <div class="column is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            Référence ADV
          </div>
          <div class="column is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="$emit('sort', 'lot_ref', $event)"
              sort-id="lot_ref"
              :sort="sortBy.lot_ref"
              label="Lot"></sortable>
          </div>
          <div class="column is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="$emit('sort', 'contact_name', $event)"
              sort-id="contact_name"
              :sort="sortBy.contact_name"
              label="Contact"></sortable>
          </div>
          <div class="column is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="$emit('sort', 'origin_name', $event)"
              sort-id="origin_name"
              :sort="sortBy.origin_name"
              label="Origine"></sortable>
          </div>
          <div class="column is-th is-paddingless-right is-padding-bottom-small is-padding-left-small is-3">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="$emit('sort', 'sale_price_ttc', $event)"
              sort-id="sale_price_ttc"
              :sort="sortBy.sale_price_ttc"
              label="Prix de Vente"></sortable>
          </div>
        </div>
        <div class="columns column is-4">
          <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="$emit('sort', 'seller_com', $event)"
              sort-id="seller_com"
              :sort="sortBy.seller_com"
              label="Com Vendeur"></sortable>
          </div>
          <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="$emit('sort', 'company_com', $event)"
              sort-id="company_com"
              :sort="sortBy.company_com"
              label="Com Société"></sortable>
          </div>
          <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
            <sortable
              icon-asc="fas fa-sort-up"
              icon-desc="fas fa-sort-down"
              icon-default="fas fa-sort"
              :default-sort="true"
              @sort="$emit('sort', 'CA_immo', $event)"
              sort-id="CA_immo"
              :sort="sortBy.CA_immo"
              label="Com Ventes"></sortable>
          </div>
        </div>
      </div>
    </div>

    <div class="statisticsRows-lignes is-size-6-touch is-size-6-desktop is-size-5-widescreen">
      <stats-sales-row
        :has-col-program="false"
        v-for="s in sortedSales"
        :key="s.pk"
        :sale="s"
        class="has-background-white is-border is-relative is-clipped is-margin-bottom-small"></stats-sales-row>
      <stats-sales-row
        :has-col-program="false"
        :sale="totalSales"
        :is-total="true"
        class="statisticsRows-ligne--synthese statisticsRows-ligne--synthese--nowrap-xLargeScreen"></stats-sales-row>
    </div>
  </div>
</template>

<script>
import StatsMixins from '@/components/statistics/StatsMixins'

export default {
  name: 'StatsProgramSales',
  components: {
    StatsSalesRow: () => import('@/components/statistics/StatsSales/StatsSalesRow')
  },
  mixins: [StatsMixins],
  watch: {
    'sourceStatsSalesPreReservation' (v) {
      this.updateSources({ salesPreReservation: v })
    },
    'sourceStatsSalesReservation' (v) {
      this.updateSources({ salesReservation: v })
    },
    'sourceStatsSalesSold' (v) {
      this.updateSources({ salesSold: v })
    }
  }
}
</script>
